export enum PagingMode {
    Offset = 'OFFSET',
    Cursor = 'CURSOR'
}
